import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { navigableProps } from '../utils/navigation';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material';
import PageHeader from '../components/common/PageHeader';
import TableSkeleton from '../components/common/TableSkeleton';
import { kundenService } from '../services/kundenService';
import { Kunde } from '../types';

const KundenListPage: React.FC = () => {
  const navigate = useNavigate();
  const [kunden, setKunden] = useState<Kunde[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadKunden = async () => {
      try {
        setLoading(true);
        const data = await kundenService.list();
        setKunden(data);
      } catch (error) {
        console.error('Fehler beim Laden der Kunden:', error);
      } finally {
        setLoading(false);
      }
    };

    loadKunden();
  }, []);

  const handleCreateClick = () => {
    navigate('/kunden/neu');
  };

  if (loading) {
    return <TableSkeleton columns={3} rows={6} />;
  }

  return (
    <Box>
      <PageHeader
        title="Kunden"
        breadcrumbs={[{ label: 'Kunden' }]}
        onAdd={handleCreateClick}
        addLabel="Neu erstellen"
      />
      <TableContainer component={Paper} sx={{ overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Unternehmensname</TableCell>
              <TableCell>E-Mail</TableCell>
              <TableCell>Rechnungskontakt</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {kunden.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  Keine Kunden gefunden
                </TableCell>
              </TableRow>
            ) : (
              kunden.map((kunde) => (
                <TableRow
                  key={kunde.id}
                  hover
                  {...navigableProps(navigate, `/kunden/${kunde.id}`)}
                  sx={{ cursor: 'pointer' }}
                >
                  <TableCell sx={{ whiteSpace: 'pre-line' }}>{kunde.name_des_unternehmens}</TableCell>
                  <TableCell>{kunde.email || '-'}</TableCell>
                  <TableCell>{kunde.rechnungskontakt || '-'}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default KundenListPage;
